import { createStore, combineReducers, applyMiddleware } from 'redux';
// import { createLogger } from 'redux-logger';  // Logger middleware, commented out for now.
import thunk from 'redux-thunk'; // Thunk middleware for handling async actions.
import reducers from './reducers'; // Combined reducers for the Redux store.
import { composeWithDevTools as compose } from 'redux-devtools-extension/developmentOnly'; // DevTools for Redux state inspection


// Middleware array containing redux-thunk.
const middleware = [thunk];

// Check the environment (development or production).
// let environment = (process.env.NODE_ENV || 'development').toString().trim().toLowerCase();

// Optionally add redux-logger in development mode
// if (typeof window !== "undefined" && environment !== 'production') {
  // Only add logger in development and client-side
  // middleware.push(createLogger());
// }

// Initial state setup - retrieve it from window.__REDUX_STATE__ if available (for SSR).
const initialState = (typeof window !== "undefined" ? window.__REDUX_STATE__ : {});

// Clean up the injected global state to prevent memory leaks (for SSR).
if (typeof window !== "undefined") {
  delete window.__REDUX_STATE__;
}

// Caching the store to avoid redundant store creation.
let cachedStore = null; 

export const createNewStore = (initialState = {}) => {
  // Return cached store if it's already created to avoid unnecessary store creation.
  if (cachedStore) {
    return cachedStore;
  }
  // Create a new Redux store with initial state and middleware.
  const store = createStore(
    combineReducers(reducers), // Combine all reducers.
    initialState, // Initial state (either from SSR or default).
    compose(applyMiddleware(...middleware)) // Apply middleware (thunk).
  );
  // Cache the store for future reuse.
  cachedStore = store;
  return store;
};

// Export the store as the default export.
export default createNewStore(initialState);

